import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { mapState } from "pinia";

import config from "../../../../../common/config";
import { useHospiceConvertToPending } from "../../store/useHospiceConvertToPending";
import { formatPhoneNumber } from "../../../../../common/vue-helpers/modifiers/value-modifier";
import { IGetVendorSlim, IVendor } from "../../../../../resources-vue/vue-interfaces/i-vendor";
import { ITypeaheadOptions } from "../../../../../resources-vue/vue-interfaces/i-typeahead";
import { VendorsService } from "../../../../../services/vendor-service";
import { enumToMap } from "../../../../../common/vue-helpers/modifiers/enum-modifiers";
import { HosAdvanceDirectives } from "../../../../../enums/ReferralEnums/HosAdvanceDirectivesEnum";
import { HosCodeStatus } from "../../../../../enums/ReferralEnums/HosCodeStatusEnum";
import { getHospiceRedirectionUrl } from "../../../../../common/get-hospice-redirection-url";

import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import TypeaheadInput from "../../../../../resources-vue/vue-custom-elements/TypeaheadInput/TypeaheadInput.vue";
import PlacesAutocomplete from "../../../../../resources-vue/vue-custom-elements/PlacesAutocomplete/PlacesAutocomplete.vue";
import StateTypeahead from "../../../../../resources-vue/vue-custom-elements/StateTypeahead/StateTypeahead.vue";
import AddDocument from "../../../../../resources-vue/vue-custom-elements/AddDocument/AddDocument.vue";

export default defineComponent({
    components: {
        FormSection,
        TypeaheadInput,
        PlacesAutocomplete,
        StateTypeahead
    },

    data() {
        return {
            dialogRef: null,
            _redirectURL: null as string,
            _vendorsService: null,
            selectedVendor: null as ITypeaheadOptions,
            selectedState: null as ITypeaheadOptions,
            HosAdvanceDirectivesEnum: HosAdvanceDirectives,
            HosCodeStatusEnum: HosCodeStatus,
            formatPhoneNumber,
            enumToMap,
        };
    },

    computed: {
        ...mapState(useHospiceConvertToPending, ["application", "patientDetails", "accountId", "patientId"])
    },

    created() {
        this._vendorsService = Container.instance.get(VendorsService);
        this._redirectURL = `${getHospiceRedirectionUrl(String(this.accountId))}/create/vendor?accountId=${this.accountId}`;
    },

    watch: {
        selectedState(newValue, oldValue) {
            if (newValue == oldValue) {
                return;
            }
            if (!!this.selectedState) {
                this.patientDetails.patientFuneralHome.state = this.selectedState.value;
            } else {
                this.patientDetails.patientFuneralHome.state = "";
            }
        }
    },

    methods: {
        handleAdvDirectivesSelection(value: number) {
            if (this.patientDetails.advancedDirective.advancedCarePlanDirectives.includes(value)) {
                this.patientDetails.advancedDirective.advancedCarePlanDirectives =
                    this.patientDetails.advancedDirective.advancedCarePlanDirectives.filter(
                        (val: number) => val !== value
                    );
            } else {
                this.patientDetails.advancedDirective.advancedCarePlanDirectives.push(value);
            }
        },

        handleCodeStatusSelection(value: number) {
            if (this.patientDetails.advancedDirective.codeStatus.includes(value)) {
                this.patientDetails.advancedDirective.codeStatus =
                    this.patientDetails.advancedDirective.codeStatus.filter((val: number) => val !== value);
            } else {
                this.patientDetails.advancedDirective.codeStatus.push(value);
            }
        },

        async getVendorList(filter: string, limit: number) {
            const payload = {
                accountId: this.accountId,
                name: filter,
                providerIds: [this.patientDetails.providerId],
                application: this.application
            };
            let vendorsList = await this._vendorsService.getVendorByTerm(payload);
            return this.vendorResToTypeahead(vendorsList);
        },

        vendorResToTypeahead(vendors: IGetVendorSlim[]): ITypeaheadOptions[] {
            return vendors.map((vendor) => ({
                name: vendor.name,
                value: vendor.id
            }));
        },

        async updateVendor(vendor: any) {
            this.selectedVendor = vendor;
            const payload = {
                id: vendor.value,
                accountId: this.accountId,
                application: this.application
            };
            let vendorDetails: IVendor = await this._vendorsService.getVendorById(payload);
            this.patientDetails.patientFuneralHome.name = vendorDetails.name;
            this.patientDetails.patientFuneralHome.address = vendorDetails.address.addressLine1;
            this.patientDetails.patientFuneralHome.city = vendorDetails.address.city;
            this.patientDetails.patientFuneralHome.state = vendorDetails.address.state;
            this.patientDetails.patientFuneralHome.zipCode = vendorDetails.address.zipCode;
        },

        valueUpdated(value: string, type?: string) {
            let number =
                value
                    .split("")
                    ?.map((item) => (Number(item) || item == "0" ? item : ""))
                    .join("") || "";

            if (type == "primary") {
                this.patientDetails.patientFuneralHome.phoneNumber = number;
            } else {
                this.patientDetails.patientFuneralHome.afterHrsPhoneNumber = number;
            }
        },

        openAddDocumentModal() {
            this.dialogRef = this.$dialog.open(AddDocument, {
                props: {
                    modal: true,
                    showHeader: false,
                    style: {
                        width: "40vw"
                    }
                },

                data: {
                    application: this.application,
                    accountId: this.accountId,
                    patientId: this.patientId,
                    providerId: this.patientDetails.providerId,
                    referralId: this.patientDetails.referralId
                }
            });
        }
    }
});
